import { useEffect } from "react";

export type FetchOptionsProps = {
  fetch: () => Promise<unknown>;
  unload: () => void;
};

export function FetchOptions({ fetch, unload }: FetchOptionsProps): null {
  useEffect(() => {
    void fetch();

    return () => {
      unload();
    };
  }, [fetch, unload]);

  return null;
}
